
import PricingButton from "@/components/main/pricing/PricingButton";
import RedHeadBox from "@/components/main/core/RedHeadBox";
import SearchCircle from "@/components/main/core/SearchCircle"

import tube8 from "@/assets/images/main/example/xxx/tube8.png"
import hclips from "@/assets/images/main/example/xxx/hclips.png"
import nuvid from "@/assets/images/main/example/xxx/nuvid.png"
import pornhub from "@/assets/images/main/example/xxx/pornhub.png"
import redtube from "@/assets/images/main/example/xxx/redtube.png"
import tna from "@/assets/images/main/example/xxx/tna.png"
import upornia from "@/assets/images/main/example/xxx/upornia.png"
import xtube from "@/assets/images/main/example/xxx/xtube.png"
import youporn from "@/assets/images/main/example/xxx/youporn.png"

import data from "@/mixins/data";
import isMobile from "@/mixins/isMob";
import gsap from "gsap";
export default {
  name: "XXXTab",
  components: { PricingButton, RedHeadBox, SearchCircle },
  mixins: [data, isMobile],
  data() {
    return {
      date: new Date(),
      complete: false,
      xxxServices: [
        {
          logo: tube8,
          isFound: false,
          email: '',
          service: 'tube8.com'
        },
        {
          logo: hclips,
          isFound: true,
          email: 'name@email.com',
          service: 'hclips.com'
        },
        {
          logo: nuvid,
          isFound: true,
          email: 'name@email.com',
          service: 'nuvid.com'
        },
        {
          logo: pornhub,
          isFound: false,
          email: '',
          service: 'pornhub.com'
        },
        {
          logo: redtube,
          isFound: true,
          email: 'name@email.com',
          service: 'redtube.com'
        },
        {
          logo: tna,
          isFound: false,
          email: '',
          service: 'tnaflix.com'
        },
        {
          logo: upornia,
          isFound: true,
          email: 'name@email.com',
          service: 'upornia.com'
        },
        {
          logo: xtube,
          isFound: false,
          email: '',
          service: 'xtube.com'
        },
        {
          logo: youporn,
          isFound: true,
          email: 'name@email.com',
          service: 'youporn.com'
        },
      ]
    }
  },
  methods: {
    datenow() {
      if (this.date.getMinutes())
        return `${this.date.getDate()}/${this.date.getMonth() + 1}/${this.date.getFullYear()} ${this.date.getHours()}:${+this.date.getMinutes() <= 10 ? '0' + this.date.getMinutes() : this.date.getMinutes()}`
    },
    beforeEnter(el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(60px)'
    },

    enter(el) {
      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 1,
        delay: el.dataset.index*0.6
      })
    },

    end(is) {
      this.complete = is;
    }
  }

}
